/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React components
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

//images
import consultImage from "assets/images/consultoria.png";
import penTestImage from "assets/images/pen-test.png";

function Produtos_Grade() {
  const callConsultoria = {
    type: "internal",
    route: "/pages/ajuda/contate-nos",
    color: "dark",
    label: "Saiba mais",
  };
  
  const callPenetration = {
    type: "internal",
    route: "/pages/ajuda/contate-nos",
    color: "dark",
    label: "Saiba mais",
  };

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid
          container
          item
          flexDirection="column"
          alignItems="center"
          xs={12}
          lg={6}
          sx={{ textAlign: "center", mx: "auto" }}
        >
        <MKTypography variant="h2" mb={4}>
            Explore nossos serviços{" "}
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Serviços desenvolvidos para atender necessidades específicas de cada cliente, buscando
            sempre a correta implementação para lhe atender.
          </MKTypography>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 3 }} justifyContent={"center"}>
          <Grid item xs={12} md={6} lg={4}>
            <MKBox mt={3}>
              <SimpleBlogCard
                image={consultImage}
                title="Consultoria Cibernética"
                description="A nossa consultoria cibernética nos permite de auxiliar nosssos clientes para identificar oportunidades e necessidades de desenvolvimento cibernético."
                action={callConsultoria}
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MKBox mt={3}>
              <SimpleBlogCard
                image={penTestImage}
                title="Penetration Testing"
                description="O teste de penetraçao é uma atividade extremamente necessária, e que deve ser executada com regularidade para auxiliar na proteçao da sua empresa."
                action={callPenetration}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Produtos_Grade;
